import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import store from './store';
import ResetPassword from './views/ResetPassword.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        guest: true,
      },
    },
    {
      path: '/nytt-passord',
      name: 'reset-password',
      component: ResetPassword,
      meta: {
        guest: true,
      },
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/oppgjor',
      name: 'invoices',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/Invoices.vue'),
    },
    {
      path: '/bookinger',
      name: 'bookings',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/Bookings.vue'),
    },
    {
      path: '/bookinger/list/:id?',
      name: 'bookings.list',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/Bookings.vue'),
    },
    {
      path: '/bookinger/ny-dato',
      name: 'bookings.new-date',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/AddDate.vue'),
    },
    {
      path: '/produkter',
      name: 'products',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/Products.vue'),
    },
    {
      path: '/produkter/:product_id/codes',
      name: 'products.codes',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/ProductCodes.vue'),
    },
    {
      path: '/inbox',
      name: 'messages',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/Messages.vue'),
    },
    {
      path: '/inbox/compose',
      name: 'messages.compose',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/NewMessage.vue'),
    },
    {
      path: '/inbox/:id',
      name: 'messages.show',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/Message.vue'),
    },
    {
      path: '/bedriftsopplysninger',
      name: 'companyInfo',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/CompanyInfo.vue'),
    },
    {
      path: '/brukeropplysninger',
      name: 'userInfo',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "invoices" */ './views/UserInfo.vue'),
    },
    {
      path: '/verdibevis',
      name: 'certificateOfValue',
      component: () => import('./views/CertificateOfValue.vue'),
    },
    {
      path: '/oppgjoor',
      name: 'Settlement',
      component: () => import('./views/Settlement.vue'),
    },
    {
      path: '/kontoopplysninger',
      name: 'AccountInformation',
      component: () => import('./views/AccountInformation.vue'),
    },
    {
      path: '/quick-guide',
      name: 'QuickGuide',
      component: () => import('./views/QuickGuide.vue'),
    },
    {
      path: '/kunskapsbase',
      name: 'KnowledgeBase',
      component: () => import('./views/KnowledgeBase.vue'),
    },
   {
      path: '/youwish-partner-portal',
      name: 'YouWishPartnerPortal',
      component: () => import('./views/YouWishPartnerPortal.vue'),
    },
    {
      path: '/login-og-flem-passord',
      name: 'LoginOrResetPassword',
      component: () => import('./views/LoginOrResetPassword.vue'),
    },
    {
      path: '/vanlige',
      name: 'FAQ',
      component: () => import('./views/FAQ.vue'),
    },
    {
      path: '/ok-salget-hos-youwish.no',
      name: 'IncreaseSales',
      component: () => import('./views/IncreaseSales.vue'),
    },
    {
      path: '/opplevelsesprodukter',
      name: 'ExperienceProducts',
      component: () => import('./views/ExperienceProducts.vue'),
    },
    {
      path: '/regnskapsbilag',
      name: 'AccountingDocuments',
      component: () => import('./views/AccountingDocuments.vue'),
    },
    {
      path: '/policy-for-kunder',
      name: 'CustomerPolicy',
      component: () => import('./views/CustomerPolicy.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.guest)) {
    next();
  } else {
    const isLoggedIn = store.getters['auth/isLoggedIn']
    const isRoleSupplier = store.getters['auth/isRoleSupplier']

    if (isLoggedIn && isRoleSupplier) {
        if (router.currentRoute.query.redirect) {
          const path = router.currentRoute.query.redirect;
          router.currentRoute.query.redirect = null;
          next({
            path,
          });
          return;
        }
        next();
        return;
    }

    next({
      path: '/login',
      params: { nextUrl: to.fullPath },
    });
  }
});

export default router;
